var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "auto"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索母液..."
    },
    on: {
      "on-change": _vm.searchMaterial
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.searchMaterial
    },
    slot: "append"
  })], 1), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadMaterial
    }
  }), _vm.user.superAdmin || _vm.arrayIntersection(['allFactoryLeader', 'factoryLeader'], _vm.user.simpleRole).length > 0 ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openEditMaterialDrawer();
      }
    }
  }, [_vm._v("新增母液")]) : _vm._e()], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.semiMaterialList,
      "height": _vm.tableHeight
    }
  })], 1), _c('EditMaterialDrawer', {
    ref: "EditMaterialDrawer",
    on: {
      "editSuccess": _vm.loadMaterial
    }
  }), _c('EditSemiMaterialDrawer', {
    ref: "EditSemiMaterialDrawer",
    on: {
      "addSuccess": _vm.loadMaterial
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }